<template>
  <div>
    <div class="tabs wow animate__animated animate__fadeIn">
      <div
        @click="currentLights = item.key"
        class="tabItem"
        :class="{ active: item.key === currentLights }"
        v-for="item in list"
        :key="item.key"
        :style="{ width: 100 / list.length + '%' }"
      >
        {{ item.tabText }}
      </div>
    </div>
    <div class="lights">
      <div class="left-light">
        <div class="text">
          {{ list[currentLights].title }}
        </div>
        <div class="desc">
          {{ list[currentLights].desc }}
        </div>
        <div class="btn" @click="navTo('/consult')">方案咨询</div>
      </div>
      <div class="right-light">
        <OssImg :src="list[currentLights].imgPath" alt="" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { navTo } from "@/utils/util";
import OssImg from "@/components/ossImg.vue";
const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
});
let currentLights = ref(0);
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  justify-content: center;
  gap: 19px;
  margin-top: 24px;
  margin-bottom: 24px;
  .tabItem {
    text-align: center;
    position: relative; /* 为伪元素提供定位上下文 */
    font-weight: 500;
    font-size: 1.5rem;
    color: #424242;
    padding-bottom: 13px; /* 为下划线留出空间 */
    cursor: pointer;
    transition: all 0.3s ease;

    /* 移除原有的border-bottom */
    border-bottom: none;
  }

  .tabItem.active {
    color: #32a89e;
  }

  .tabItem:hover {
    color: #32a89e;
  }


  /* 添加短下划线效果 */
  .tabItem::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%; /* 从中间开始 */
    width: 0; /* 初始宽度为0 */
    height: 1px;
    background-color: #32a89e;
    transform: translateX(-50%); /* 居中 */
    transition: all 0.3s ease;
  }

  /* 悬停时显示下划线 */
  .tabItem:hover::after {
    width: 80%; /* 宽度为元素宽度的一半 */
  }

  /* 当前选中项的下划线 */
  .tabItem.active::after {
    width: 80%; /* 宽度为元素宽度的一半 */
  }
}
.lights {
  display: flex;
  align-items: center;
  gap: 25px;
  height: 394px;
  .left-light {
    position: relative;
    width: 623px;
    // height: 240px;
    border-radius: 8px;
    padding: 0px 16px;
    .text {
      color: #424242;
      margin: 24px 0px 16px 0px;
      font-weight: 500;
      font-size: 16px;
    }
    .desc {
      color: #888888;
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 64px;
      text-indent: 2em;
    }
    .btn {
      position: absolute;
      bottom: 10px;
      left: 16px;
      width: 97px;
      height: 37px;
      border-radius: 8px;
      background: #32a89e;
      text-align: center;
      line-height: 37px;
      font-weight: bold;
      font-size: 16px;
      color: #FFFFFF;
      cursor: pointer;
    }
  }
}
</style>
